interface DistinctSelectOption {
  label: string;
  value: React.ReactNode;
  isSelected: boolean;
}

interface DistinctSelectProps {
  options: DistinctSelectOption[];
  onChange: (option: DistinctSelectOption) => void;
}

export const DistinctSelect = ({ options, onChange }: DistinctSelectProps) => {
  return (
    <div className="flex flex-col space-y-4">
      {options.map((option) => (
        <div
          className={`p-4 border border-solid rounded-lg ${option.isSelected ? 'border-blue-500' : 'border-gray-300'} ${
            !option.isSelected ? 'opacity-50' : ''
          }`}
          onClick={() => onChange(option)}
          key={option.label}
        >
          <div className="flex items-center">
            <input type="radio" name={option.label} checked={option.isSelected} className="mr-2" readOnly />
            {option.value}
          </div>
        </div>
      ))}
    </div>
  );
};
